import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { gitbookAuth } from "src/api/taktileApi";
import { GitbookAuthenticatedURL } from "src/clients/taktile-api";

export const useGithbookAuth = (
  gitbookPath: string,
  options: Partial<UseQueryOptions<GitbookAuthenticatedURL["url"]>> = {},
) => {
  return useQuery({
    queryKey: ["gitbookAuth", gitbookPath],
    queryFn: async () =>
      (await gitbookAuth.gitbookAuthApiV1GitbookAuthPost({ path: gitbookPath }))
        .data.url,
    ...options,
  });
};
